import { z } from 'zod';
import { RowVersionSchema } from '../common/row-version.js';
import { ResponsibilityLevelSchema } from './levels.js';
// Response schemas for the responsibilities feature. Field-exposure rule (ANATOMY §L7):
// the list row carries EVERY field a responsibility has — there is no detail endpoint
// (the edit drawer pre-fills from the row). `level` rides the precise enum (the DB CHECK
// chk_responsibilities_level guarantees membership). No `display_order`: responsibilities
// are not reordered — they sort by the level hierarchy then name (contrast site-types,
// whose curated order earns a reorder surface).
// ── GET /api/projects/:projectId/responsibilities — list row ────────────────
export const ResponsibilityListItemSchema = z
    .object({
    row_version: RowVersionSchema,
    id: z.number().int(),
    name: z.string().max(64),
    level: ResponsibilityLevelSchema,
    is_required: z.boolean(),
    is_disabled: z.boolean(),
})
    .strict();
export const ResponsibilitiesListResponseSchema = z
    .object({ items: z.array(ResponsibilityListItemSchema) })
    .strict();
// ── POST create — minimal id (FE refetches the list) ────────────────────────
export const CreatedResponsibilityResponseSchema = z.object({ id: z.number().int() }).strict();
